// @flow
import * as React from 'react';
import TimeSpent from 'app/common/lib/react/TimeSpent';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import { Box } from 'gestalt';
import { StoryPinsGrid } from 'app/common/react/components/profile/UserProfilePinGrid/UserProfilePinGrid';

type Props = {|
  isOwnProfile: boolean,
  user: ProfileUser,
|};

function ProfileStoryPins(props: Props) {
  const { isOwnProfile, user } = props;
  const { username } = user;
  const timeSpentViewParam = isOwnProfile
    ? PCONST.thrift.ViewParameterType.USER_SELF
    : PCONST.thrift.ViewParameterType.USER_OTHERS;

  return (
    <TimeSpent
      view={PCONST.thrift.ViewType.USER}
      viewParameter={timeSpentViewParam}
      component={PCONST.thrift.ComponentType.USER_STORY_PINS}
    >
      <Box>
        <StoryPinsGrid isOwnProfile={isOwnProfile} user={user} username={username} />
      </Box>
    </TimeSpent>
  );
}

export default ProfileStoryPins;
